var exports = {
  "T": "container__Nf3xhn",
  "k": "checkbox__exSH_V",
};

module.exports = exports;
